import { render, staticRenderFns } from "./public-resource-card.vue?vue&type=template&id=eb20cff8&scoped=true&"
import script from "./public-resource-card.ts?vue&type=script&lang=ts&"
export * from "./public-resource-card.ts?vue&type=script&lang=ts&"
import style0 from "./public-resource-card.scss?vue&type=style&index=0&id=eb20cff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb20cff8",
  null
  
)

export default component.exports